/* _____ Open mobile nav _____ */
let scrollTop = 0;
let $mobileNavIcon = $('.nav__mobile-menu, .header__menu-search-mobile .nav__link--icon.js-search-header');
let $mobileNav = $('.mobile-nav');
let $body = $('body');
let $html = $('html');
let $closeButtonMobileNav = $('.mobile-nav .mobile-nav__close-button');
let $predictiveSearch = $('.header__search-container');
$mobileNavIcon.on('click', function () {
  // Calculate nav container height
  let fullHeaderHeight = $('#shopify-section-header').outerHeight();
  let headerHeight = $('#StickyHeaderWrap').outerHeight();
  let mobileNavHeight = $(window).outerHeight() - fullHeaderHeight;

  // Apply height and top position on mobile nav
  $mobileNav.css({
    'height': mobileNavHeight + 'px',
    'top': fullHeaderHeight + 20 + 'px'
  });

  // Put header height on the close button mobile nav
  $closeButtonMobileNav.css({
    'height': headerHeight + 'px',
    'top': -headerHeight + 'px'
  });

  // Open or close mobile nav only when nav__mobile-menu is clicked
  if ($(this).hasClass('nav__mobile-menu')) {
    $mobileNav.toggleClass('mobile-nav--opened');
  }
  $body.toggleClass('no-scroll');
  $html.toggleClass('no-scroll');
  scrollTop = window.scrollY;
  setTimeout(function () {
    $body.toggleClass('is-fixed');
    window.scroll(0, scrollTop);
  }, 300);
});
$('.js-search-header').on('click', function () {
  if (window.matchMedia('(max-width: 1062px)').matches) {
    let fullHeaderHeight = $('#shopify-section-header').outerHeight();
    let searchOffset = fullHeaderHeight;
    $predictiveSearch.css({
      'height': 'calc(100% - ' + searchOffset + 'px)',
      'top': searchOffset + 'px'
    });
  } else {
    document.getElementById('PredictiveWrapper').classList.add('hide');
  }
});

/* _____ Close mobile nav _____ */

let $closeButton = $('.mobile-nav__close-button, .site-header__search svg');
$closeButton.on('click', function () {
  if ($(this).hasClass('mobile-nav__close-button')) {
    $mobileNav.removeClass('mobile-nav--opened');
    $body.removeClass('no-scroll');
    $body.removeClass('is-fixed');
    window.scrollTo(0, scrollTop);
  } else {
    // Only remove scroll and body classes if mobile nav is not open
    if (!$mobileNav.hasClass('mobile-nav--opened') && window.matchMedia('(max-width: 1062px)').matches) {
      $body.removeClass('no-scroll');
      $body.removeClass('is-fixed');
      window.scrollTo(0, scrollTop);
    }
  }
});

/* _____ Remove all opened classes on dropdown element when the mobile nav is closed _____*/
$closeButtonMobileNav.on('click', function () {
  let $openedDropdowns = $('.mobile-nav .linklist__item--level-2.opened, .mobile-nav .linklist__item--level-3.opened');
  let $activeDropdownsIcons = $('.mobile-nav .icon-dropdown.active');
  $openedDropdowns.removeClass('opened');
  $openedDropdowns.slideToggle(300);
  $activeDropdownsIcons.removeClass('active');
});

/* _____ Mobile menu - Open and close dropdowns _____*/

$(document).ready(function () {
  let $linksLevels = $('.linklist__title-level'); // For level 1 and level 2 dropdowns

  $linksLevels.on('click', function () {
    let $link = $(this);
    let currentLevel = parseInt($link.attr('data-level'));
    let itemId = $link.attr('id'); // To find the level 3 container corresponding to the level 2 title, we have to use the link id
    let $dropdownIcon = $link.find('.icon-dropdown');
    let $sublinksContainer = $link.closest('.linklist__item').find(`.linklist__item--level-${currentLevel + 1}#${itemId}`);

    // Check if there is another opened dropdown in the same level
    let $openedDropdown = $link.closest('.linklist').find('.linklist__title-level.opened');
    if ($openedDropdown.length) {
      if (!$openedDropdown.is($link)) {
        // toggleDropdown will be played 2 times if openedDropdown is the same as the link
        closeDropdown($openedDropdown, $openedDropdown.find('.icon-dropdown'), $openedDropdown.next()); // Close the opened dropdown
      }
    }

    // Open or close the dropdown
    toggleDropdown($link, $dropdownIcon, $sublinksContainer);
  });
});
function toggleDropdown($link, $dropdownIcon, $sublinksContainer) {
  $dropdownIcon.toggleClass('active');
  $link.toggleClass('opened');
  $sublinksContainer.toggleClass('opened');
  $sublinksContainer.slideToggle(300);
}
function closeDropdown($link, $dropdownIcon, $sublinksContainer) {
  $dropdownIcon.removeClass('active');
  $link.removeClass('opened');
  $sublinksContainer.removeClass('opened');
  $sublinksContainer.slideUp(300);
}